import { ExamPaperTable } from './ExamPaperTable';
export default ExamPaperTable;
